"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const LaunchDarklyBrowser = __importStar(require("launchdarkly-js-client-sdk"));
const settings_provider_1 = require("./settings-provider");
class LaunchDarklyBrowserSettingsProvider extends settings_provider_1.SettingsProvider {
    static async init(config) {
        if (!LaunchDarklyBrowserSettingsProvider.client) {
            if (!config) {
                throw new Error('SettingClientConfig must be passed on create method.');
            }
            const key = config.clientSideId;
            let context = { anonymous: true };
            if (config.user) {
                context = {
                    kind: 'user',
                    key: String(config.user.id),
                    name: config.user.name,
                    email: config.user.email,
                    ...config.user.additionalProps,
                };
            }
            LaunchDarklyBrowserSettingsProvider.client = LaunchDarklyBrowser.initialize(key, context);
            await LaunchDarklyBrowserSettingsProvider.client.waitForInitialization();
            LaunchDarklyBrowserSettingsProvider.client.identify(context);
        }
        return LaunchDarklyBrowserSettingsProvider;
    }
    static async get(settingName, defaultValue) {
        const setting = await LaunchDarklyBrowserSettingsProvider.client.variation(settingName, defaultValue);
        return setting;
    }
}
exports.default = LaunchDarklyBrowserSettingsProvider;
